import React, { CSSProperties } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFileLines } from '@fortawesome/free-solid-svg-icons';

interface InvoicePlusIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const iconStyle: CSSProperties = {
  position: 'relative',
  paddingLeft: '5px',
};

const iconPlusStyle: CSSProperties = {
  position: 'absolute',
  top: '8px',
  left: '-5px',
  fontSize: '10px',
};

const InvoicePlusIcon: React.FC<InvoicePlusIconProps> = ({
  onClick,
  className = '',
  style = {},
}) => (
  <div
    style={{ ...iconStyle, ...style }}
    className={`${className}`}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={faFileLines} />
    <FontAwesomeIcon icon={faPlus} style={iconPlusStyle} />
  </div>
);

export default InvoicePlusIcon;
